(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bracelet-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('bracelet-selector')) return;

  class BraceletSelector extends HTMLElement {
    connectedCallback() {
      const drawer = this.querySelector('x-drawer');

      // Le x-drawer natif se déplace dans <body> à l'ouverture ; après un re-render du
      // bloc variant_picker, un tiroir de même id peut rester orphelin → on le purge.
      if (drawer && drawer.id) {
        document.querySelectorAll('x-drawer#' + (window.CSS && CSS.escape ? CSS.escape(drawer.id) : drawer.id)).forEach((node) => {
          if (node !== drawer && !this.contains(node)) node.remove();
        });
      }

      // Les radios réels sont en ligne (dans <variant-picker>), donc la sélection — y compris
      // via un proxy du tiroir — met à jour la variante nativement. Ici on ferme le tiroir.
      this.addEventListener('change', (event) => {
        if (!drawer || !event.target || !event.target.matches('input[type="radio"]')) return;
        if (typeof drawer.hide === 'function') drawer.hide();
        else { drawer.open = false; drawer.removeAttribute('open'); }
      });
    }
  }

  customElements.define('bracelet-selector', BraceletSelector);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-alma-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('cp-alma-installments')) return;

    var ALMA_JS = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4/dist/widgets.umd.js';
    var ALMA_CSS = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4/dist/widgets.min.css';
    var almaPromise = null;

    function loadAlma() {
      if (window.Alma) return Promise.resolve(window.Alma);
      if (almaPromise) return almaPromise;
      almaPromise = new Promise(function (resolve, reject) {
        if (!document.querySelector('link[data-alma-css]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = ALMA_CSS;
          link.setAttribute('data-alma-css', '');
          document.head.appendChild(link);
        }
        var script = document.createElement('script');
        script.src = ALMA_JS;
        script.async = true;
        script.onload = function () { resolve(window.Alma); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return almaPromise;
    }

    var CpAlmaInstallments = class extends HTMLElement {
      connectedCallback() {
        if (this.__inited) return;
        var self = this;

        var merchantId = this.getAttribute('data-merchant-id');
        var amount = parseInt(this.getAttribute('data-amount'), 10);
        var mode = this.getAttribute('data-api-mode') === 'test' ? 'TEST' : 'LIVE';
        var locale = this.getAttribute('data-locale') || 'fr';
        var trigger = this.querySelector('.cp-alma-installments__more');
        var container = this.querySelector('.cp-alma-installments__modal');

        if (!merchantId || !amount || !trigger || !container) return;

        loadAlma().then(function (Alma) {
          if (self.__inited || !Alma || !Alma.Widgets) return;
          self.__inited = true;

          var widgets = Alma.Widgets.initialize(merchantId, Alma.ApiMode[mode] || Alma.ApiMode.LIVE);
          widgets.add(Alma.Widgets.Modal, {
            container: '#' + container.id,
            purchaseAmount: amount,
            locale: locale,
            clickableSelector: '#' + trigger.id
          });
        }).catch(function () {});
      }
    };

    window.customElements.define('cp-alma-installments', CpAlmaInstallments);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-card-media-swipe"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('cp-card-swipe')) return;

    var CpCardSwipe = class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cp-card-swipe__track');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.cp-card-swipe__slide'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('.cp-card-swipe__dot'));
        if (!this.track || this.slides.length < 2) return;

        if (this.dots.length) {
          var self = this;
          this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var index = self.slides.indexOf(entry.target);
              if (index < 0) return;
              self.dots.forEach(function (dot, di) {
                dot.classList.toggle('is-active', di === index);
              });
            });
          }, { root: this.track, threshold: 0.6 });
          this.slides.forEach(function (slide) { self.observer.observe(slide); });
        }

        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        var dot = event.target.closest('.cp-card-swipe__dot');
        if (!dot || !this.dots.length) return;
        event.preventDefault();
        var index = this.dots.indexOf(dot);
        if (index < 0 || !this.slides[index]) return;
        this.track.scrollTo({ left: this.slides[index].offsetLeft, behavior: 'smooth' });
      }
    };

    window.customElements.define('cp-card-swipe', CpCardSwipe);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-facets-drawer-live"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('cp-facets-drawer-live')) return;

    var DEBOUNCE_MS = 250;
    var CLEAR_ON_EMPTY = ['page', 'filter.v.price.gte', 'filter.v.price.lte'];

    function escapeId(id) {
      return (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    }

    var CpFacetsDrawerLive = class extends HTMLElement {
      connectedCallback() {
        this.drawer = document.getElementById('facets-drawer');
        if (!this.drawer) return;
        this.facetsForm = this.drawer.querySelector('facets-form');
        if (!this.facetsForm) return;

        this.labelTemplate = this.dataset.resultsLabel || '';
        this.abortController = null;
        this.timer = null;
        this.onChange = this.onChange.bind(this);
        this.facetsForm.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        if (this.facetsForm) this.facetsForm.removeEventListener('change', this.onChange);
        if (this.abortController) this.abortController.abort();
        clearTimeout(this.timer);
      }

      onChange(event) {
        var target = event.target;
        // Le tri n'affecte pas les compteurs ni la disponibilité → inutile de recharger.
        if (!target || target.name === 'sort_by') return;

        clearTimeout(this.timer);
        var self = this;
        this.timer = setTimeout(function () { self.refresh(); }, DEBOUNCE_MS);
      }

      buildUrl() {
        var form = this.facetsForm.querySelector('form');
        var url = new URL(form.action, window.location.origin);
        url.search = '';
        new URLSearchParams(new FormData(form)).forEach(function (value, key) {
          url.searchParams.append(key, value);
        });
        CLEAR_ON_EMPTY.forEach(function (key) {
          if (url.searchParams.get(key) === '') url.searchParams.delete(key);
        });
        url.searchParams.set('section_id', this.facetsForm.getAttribute('section-id'));
        return url;
      }

      async refresh() {
        var form = this.facetsForm.querySelector('form');
        if (!form) return;

        if (this.abortController) this.abortController.abort();
        var controller = new AbortController();
        this.abortController = controller;

        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        try {
          var response = await fetch(this.buildUrl().toString(), { signal: controller.signal });
          var text = await response.text();
          if (controller.signal.aborted) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          this.applyUpdate(doc);
        } catch (error) {
          // Requête annulée par un clic suivant, ou erreur réseau → on ignore silencieusement.
        } finally {
          if (this.abortController === controller) {
            this.abortController = null;
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          }
        }
      }

      applyUpdate(doc) {
        var fetchedForm = doc.querySelector('#facets-drawer-form');
        fetchedForm = fetchedForm ? fetchedForm.closest('facets-form') : doc.querySelector('facets-form');
        if (!fetchedForm) return;

        // 1. On mémorise l'état à préserver (focus + accordéons ouverts).
        var activeId = document.activeElement ? document.activeElement.id : '';
        var openKeys = this.captureOpenKeys(this.facetsForm);

        // 2. On remplace UNIQUEMENT le contenu du <facets-form> (l'élément lui-même reste → ses
        //    écouteurs natifs survivent, et le conteneur scrollable du drawer n'est pas touché).
        var imported = document.importNode(fetchedForm, true);
        this.facetsForm.replaceChildren.apply(this.facetsForm, Array.prototype.slice.call(imported.childNodes));

        // 3. On restaure les accordéons ouverts puis le focus.
        this.restoreOpenKeys(this.facetsForm, openKeys);
        if (activeId) {
          var toFocus = this.facetsForm.querySelector('#' + escapeId(activeId));
          if (toFocus) {
            try { toFocus.focus({ preventScroll: true }); } catch (e) { toFocus.focus(); }
          }
        }

        // 4. On met à jour le bouton « Voir les résultats (N) ».
        var collectionEl = doc.querySelector('#collection');
        if (collectionEl) this.updateButton(collectionEl.getAttribute('data-results-count'));
      }

      detailsKey(details) {
        var input = details.querySelector('input[name]');
        return input ? input.name : '';
      }

      captureOpenKeys(root) {
        var keys = {};
        var self = this;
        root.querySelectorAll('details').forEach(function (details) {
          if (details.open) {
            var key = self.detailsKey(details);
            if (key) keys[key] = true;
          }
        });
        return keys;
      }

      restoreOpenKeys(root, keys) {
        var self = this;
        root.querySelectorAll('details').forEach(function (details) {
          var key = self.detailsKey(details);
          if (key) details.open = !!keys[key];
        });
      }

      updateButton(count) {
        if (count === null || count === undefined) return;
        var button = this.drawer.querySelector('.cp-facets-apply');
        if (!button) return;

        var label = this.labelTemplate ? this.labelTemplate.replace('{count}', count) : String(count);
        var content = button.querySelector('button-content');
        if (content) {
          content.textContent = label;
          // L'animation de bouton (rotation/up) duplique le texte via un attribut → le garder synchro.
          if (content.hasAttribute('rotated-text')) content.setAttribute('rotated-text', label);
          if (content.hasAttribute('up-text')) content.setAttribute('up-text', label);
        } else {
          button.textContent = label;
        }
      }
    };

    window.customElements.define('cp-facets-drawer-live', CpFacetsDrawerLive);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-sticky-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('cp-sticky-filters')) return;

    var CpStickyFilters = class extends HTMLElement {
      connectedCallback() {
        this.setupHeaderHide();

        var scope = this.closest('.shopify-section') || document;
        this.toolbar = scope.querySelector('.collection__toolbar');
        this.sentinel = scope.querySelector('.cp-toolbar-sentinel');
        if (!this.toolbar || !this.sentinel) return;

        var self = this;
        // Ombre uniquement une fois la toolbar collée : la sentinelle (placée juste avant la toolbar)
        // sort du haut du viewport → on active .is-stuck. Pas de listener scroll.
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            self.toolbar.classList.toggle('is-stuck', !entry.isIntersecting);
          });
        }, { threshold: 0 });
        this.observer.observe(this.sentinel);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      // Header escamotable au SCROLL. Comportement (validé client 2026-07-16) :
      //  - scroll vers le bas  → header (logo+menu) se cache, la barre de filtres reste sticky ;
      //  - scroll vers le haut → la barre de filtres reste, mais le header NE réapparaît PAS ;
      //  - le header ne revient QUE tout en haut de la page (scroll ≈ 0).
      // Natif hide_on_scroll laissé OFF (son réveil au survol du haut recouvrait/bloquait la barre de filtres).
      setupHeaderHide() {
        if (window.__cpHeaderHideBound) return;
        var header = document.querySelector('x-header.header');
        if (!header) return;
        window.__cpHeaderHideBound = true;

        var mq = window.matchMedia('(min-width: 700px)');
        var lastY = Math.abs(window.scrollY);
        var ticking = false;

        function reveal(hidden) {
          if (hidden && header.querySelectorAll('[open]').length) return; // ne pas cacher si un menu est ouvert
          header.classList.toggle('is-hidden', hidden);
          document.documentElement.style.setProperty('--header-is-visible', hidden ? '0' : '1');
        }
        // Seuil « tout en haut » : le header ne réapparaît qu'une fois revenu au sommet de la page.
        var TOP_REVEAL = 8;
        function onScroll() {
          if (ticking || !mq.matches) return; // desktop/tablette uniquement
          ticking = true;
          requestAnimationFrame(function () {
            var y = Math.abs(window.scrollY);
            if (y <= TOP_REVEAL) { lastY = y; reveal(false); }                  // tout en haut → header revient
            else if (y > lastY && y - lastY > 100) { lastY = y; reveal(true); } // scroll vers le bas → header se cache
            else if (y < lastY) { lastY = y; }                                  // scroll vers le haut → NE PAS réafficher (la barre de filtres reste)
            ticking = false;
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        mq.addEventListener('change', function (e) { if (!e.matches) { reveal(false); } lastY = Math.abs(window.scrollY); });
      }
    };

    window.customElements.define('cp-sticky-filters', CpStickyFilters);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["thumb-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('thumb-selector')) return;

  class ThumbSelector extends HTMLElement {
    connectedCallback() {
      const drawer = this.querySelector('x-drawer');

      // Le x-drawer natif peut migrer dans <body> ; après un re-render du bloc, purge l'orphelin de même id.
      if (drawer && drawer.id) {
        const sel = 'x-drawer#' + (window.CSS && CSS.escape ? CSS.escape(drawer.id) : drawer.id);
        document.querySelectorAll(sel).forEach((node) => {
          if (node !== drawer && !this.contains(node)) node.remove();
        });
      }

      // Mode radios : la sélection (y compris via un proxy du tiroir) met à jour la variante → on ferme le tiroir.
      // Mode links : rien à faire (le clic navigue vers le produit).
      this.addEventListener('change', (event) => {
        if (!drawer || !event.target || !event.target.matches('input[type="radio"]')) return;
        if (typeof drawer.hide === 'function') drawer.hide();
        else { drawer.open = false; drawer.removeAttribute('open'); }
      });
    }
  }

  customElements.define('thumb-selector', ThumbSelector);
})();
  } catch(e) { console.error(e); }
})();

})();
